<!-- eslint-disable indent  -->
<script setup lang="ts">
import { computed, ref, inject } from "vue";
import { getValue, RemoteConfig } from "firebase/remote-config";
import { useRouter } from "vue-router";
import BottomNavigationButton from "./BottomNavigationButton.vue";
import { show } from "@intercom/messenger-js-sdk";
import { storeToRefs } from "pinia";
import { useAppStore } from "@/store/App";

const router = useRouter();
const remoteConfig = inject("remoteConfig") as RemoteConfig;
const { isOffline } = storeToRefs(useAppStore());

const enableHelpScout = computed(() => {
  return getValue(remoteConfig, "EnableHelpScout")._value === "true";
});


function openHelp() {
  if(isOffline.value){
    return;
  }
  show();
  //Beacon("toggle");
}

function handleButtonClick(route: string) {
  router.push({ name: route });
}
</script>
<template>
  <nav role="navigation" class="bg-white fixed bottom-0 left-0 right-0 flex justify-evenly  mb-2 " aria-label="bottom-nav">
    <div data-testid="Home" @click="handleButtonClick('Home')">
      <BottomNavigationButton titleValue="Home" :selected="$route.meta.parent==='Home'">
        <i class="fas fa-house" alt="home button image" ></i>
      </BottomNavigationButton>
    </div>  
    <div data-testid="Your Event"  @click="handleButtonClick('YourEvents')">
      <BottomNavigationButton titleValue="Your Events" :selected="$route.meta.parent==='YourEvents'">
        <i class="fas fa-calendar-check" ></i>
      </BottomNavigationButton>
    </div>
    <div data-testid="Manage Events"  @click="handleButtonClick('MyHostedEvents')">
      <BottomNavigationButton titleValue="Manage Events" :selected="$route.meta.parent==='MyHostedEvents'">
        <i class="fas fa-calendar-plus"></i>
      </BottomNavigationButton>

    </div> 
    <div v-if="enableHelpScout" data-testid="Help" @click="openHelp()">
      <BottomNavigationButton titleValue="Help" :selected="false" >       
        <i class="fas fa-question" ></i>
      </BottomNavigationButton>
    </div>
  </nav>
</template>

<style scoped>
.btn-container-foreground {
  position: fixed;
  display: flex;
  align-items: flex-end;
  direction: ltr;
  bottom: 0;
  width: 100%;
  z-index: 2147483000;
  height: 64px;
  box-shadow: 0 0 10px 0 #eee;
  color: #0000008a;
  box-sizing: border-box;
  line-height: 1.5 !important;
}

.btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-basis: 100%;
  transition: all 0.3s;
  box-sizing: border-box;
  padding: 10px 0;
}

@media (min-width: 576px) {
  .btn-container {
    cursor: pointer;
  }
}

.btn-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.btn-item .help-icon {
  height: 26px;
  width: 26px;
}

.btn-item img,
.btn-item svg {
  height: 26px;
  width: 26px;
}

.btn-item .icon {
  height: 26px;
  width: 26px;
}

.btn-item .icon i {
  font-size: 26px;
}

.btn-icon {
  position: relative;
}

.btn-border {
  position: absolute;
  top: 0;
  height: 2px;
  background-color: #335081;
  animation: border-top 0.2s ease-in-out forwards;
}

.btn-title {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

@keyframes border-top {
  0% {
    width: 5px;
  }

  100% {
    width: 90%;
  }
}
</style>
